import { ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { OpenLinkById } from '../../common/services/openlinkbyid';

@Component({
  selector: 'app-aicpa',
  templateUrl: './aicpa.component.html',
  styleUrls: ['./aicpa.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AICPAComponent implements OnInit {

  header: string;
  subtext: string;
  description: string;
  accordion: { key: string, value: any[] }[] = [];
  notesHeader: string;
  notesBody: string;
  copyrightNoticeHeader: string;
  copyrightNoticeBody: string;
  archiveLibraryBody: string;
  archiveLibraryLink: string;
  s3baseurl: string;
  accordiandata: any;
  constructor(private commonDataServices: CommonDataService, private graphQlServices: GraphqlService, private sanitizer: DomSanitizer, private router: Router, private openlink: OpenLinkById) {
  }

  ngOnInit(): void {
    
    this.commonDataServices.showLoader.next(true);
    this.graphQlServices.getAICPALabels().subscribe(data => {
      var  aicpadata = data?.content?.data;
      let accordionData = [];
      this.header = aicpadata?.pageHeader ;
      this.subtext = aicpadata?.imp_msg;
      this.description = aicpadata?.description;
      this.accordiandata = aicpadata?.accodianPdflinks;
     
      this.notesHeader = aicpadata?.para1heading;
      this.notesBody = aicpadata?.para1body;
      this.copyrightNoticeHeader = aicpadata?.para2heading;
      this.copyrightNoticeBody = aicpadata?.para2body;
      this.archiveLibraryBody = aicpadata?.archivelibrarybody;
      this.archiveLibraryLink = aicpadata?.archivelink;
      this.commonDataServices.showLoader.next(false);
     
    }, err => {
      console.log(err);
      this.commonDataServices.showLoader.next(false);
    });
    this.graphQlServices.getS3BucketPath().subscribe(data => {
      this.s3baseurl = data;
    });
  }

  getLabel(_key: string, _labels:any): any {
    return _labels.filter(x => x.key == _key).map(y => y.value);
  }

  openLinkById(event) {
    event.preventDefault();
    this.openlink.openLinkById(event, true);
  }
  onRightClick(event, data?: any) {
    let id = event.target.id;
    if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {
      event.currentTarget.href = '/layoutComponents/getPdf?isSitesBucket=true'+'&fileName=' + id;
    }
  }

}
